module.exports = __webpack_public_path__ + "img/revisao3.f8ed7515.jpg";